import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BackButtonComponent } from '../../shared/components/back-button/back-button.component';
import { OrganizationListComponent } from '../../shared/components/organization-list/organization-list.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

/** Standalone "which organization am I in" page -- reachable without an
 *  active org (e.g. a deactivated-membership redirect from auth.service, or
 *  the organization.resolver no-org-in-JWT case), so this route carries no
 *  authGuard. The nav no longer links here directly; from a normal signed-in
 *  session, use Settings > Organization instead (organization-settings
 *  embeds the same app-organization-list). */
@Component({
  selector: 'app-organizations',
  standalone: true,
  imports: [BackButtonComponent, OrganizationListComponent, TranslatePipe],
  templateUrl: './organizations.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './organizations.component.css',
})
export class OrganizationsComponent {}
